<template>
  <div>
    <div class="section">
      <div class="section-header">
        <h3>납부정보</h3>
      </div>
      <div class="section-body">
        <dl class="field-group">
          <dt class="field-label">
            출금결제동의
          </dt>
          <dd class="field-control">
            <div id="checkbox-container-pay-agreement" class="input-container">
              <input
                id="pay-agreement"
                v-model="registration.wdrwAgrYn"
                type="checkbox"
                name="pay-agreement"
                true-value="Y"
                false-value="N"
                class="input-checkbox input-text"
                title="출금결제동의여부"
                ref="ref_payAgreement"
              />
              <label for="pay-agreement" class="input-label"
                ><em class="primary-text">(필수)</em> 동의</label
              >
            </div>
            <ul class="notice-text-list">
              <li class="notice-text">
                본인(예금주 또는 회원)이 납부하여야 할 요금에 대해 별도의 통지
                없이 상기 본인의 지정계좌(카드번호)에서 지정된 송금(결제)일에
                인출(결재) 하여 주시기 바랍니다.
              </li>
            </ul>
          </dd>
        </dl>

        <dl class="field-group">
          <dt class="field-label">
            요금납부
          </dt>
          <dd class="field-control">
            <div class="field-control-sub">
              <div
                id="radio-button-container-pay-info-bank"
                class="input-container input-horizontal"
                @change="changePayType"
              >
                <input
                  id="pay-type-bank"
                  v-model="registration.paymMthdDivsCd"
                  type="radio"
                  name="pay-info"
                  value="B"
                  class="input-radio"
                  title="요금납부방법선택"
                  ref="ref_payInfo"
                />
                <label for="pay-type-bank" class="input-label">은행</label>
              </div>
              <div
                id="radio-button-container-pay-info-card"
                class="input-container input-horizontal"
                @change="changePayType"
              >
                <input
                  id="pay-type-card"
                  v-model="registration.paymMthdDivsCd"
                  type="radio"
                  name="pay-info"
                  value="C"
                  class="input-radio"
                  title="요금납부방법선택"
                />
                <label for="pay-type-card" class="input-label">카드</label>
              </div>
              <div
                id="radio-button-container-pay-info-giro"
                class="input-container input-horizontal"
                @change="changePayType"
              >
                <input
                  id="pay-type-giro"
                  v-model="registration.paymMthdDivsCd"
                  type="radio"
                  name="pay-info"
                  value="G"
                  class="input-radio"
                  title="요금납부방법선택"
                />
                <label for="pay-type-giro" class="input-label">지로</label>
              </div>
            </div>

            <div
              v-if="registration.paymMthdDivsCd === 'B'"
              class="field-control-sub"
            >
              <dl class="field-control-sub sub-form">
                <dt>
                  <label
                    for="pay-select-bankname"
                    class="input-sub-text w120 mw100"
                    >은행</label
                  >
                </dt>
                <dd>
                  <select
                    id="pay-select-bankname"
                    v-model="registration.onetBankCd"
                    name="banks"
                    class="input-width-medium"
                    title="납부가능한 은행명 선택"
                    ref="ref_banks"
                    @change="changeBankCd($event)"
                  >
                    <option value="">선택해주세요</option>
                    <option
                      v-for="(bank, index) in bankList"
                      :key="index"
                      :value="bank.cmmCdv"
                      >{{ bank.cmmCdvNm }}</option
                    >
                  </select>
                </dd>
              </dl>
              <dl class="field-control-sub sub-form">
                <dt>
                  <label
                    for="account-number-payment"
                    class="input-sub-text w120 mw100"
                    >계좌번호</label
                  >
                </dt>
                <dd>
                  <input
                    v-model="registration.acctCardNo"
                    id="account-number-payment"
                    type="text"
                    name="accountNo"
                    autocomplete="off"
                    placeholder="'-' 없이 입력하세요"
                    class="input-text input-width-medium input-font "
                    title="납부가능한 계좌번호입력"
                    maxlength="20"
                    @input="onlyNumber"
                    ref="ref_accountNo"
                  />
                </dd>
                <div class="field-control-sub">
                  <div class="m-input-half">
                    <button
                      @click="getPymInfoVaildationCheck"
                      type="submit"
                      class="m-right m-input-half-sub"
                      ref="ref_bankSubmit"
                    >
                      인증하기
                    </button>
                  </div>
                </div>
              </dl>
            </div>

            <div
              v-if="registration.paymMthdDivsCd === 'C'"
              class="field-control-sub"
            >
              <dl class="field-control-sub sub-form">
                <dt>
                  <label
                    for="pay-select-cardname"
                    class="input-sub-text w120 mw100"
                    >카드사</label
                  >
                </dt>
                <dd>
                  <select
                    id="pay-select-cardname"
                    v-model="registration.onetCdcoCd"
                    name="card"
                    title="납부 가능한 카드사선택"
                    class="input-width-medium"
                    ref="ref_cards"
                    @change="changeCcrdCmpyCd($event)"
                  >
                    <option value="">선택해주세요</option>
                    <option
                      v-for="(card, index) in cardList"
                      :key="index"
                      :value="card.cmmCdv"
                      >{{ card.cmmCdvNm }}</option
                    >
                  </select>
                </dd>
              </dl>
              <dl class="field-control-sub sub-form">
                <dt>
                  <label class="input-sub-text w120 mw100">카드번호</label>
                </dt>
                <dd>
                  <input
                    v-model="registration.acctCardNo"
                    type="text"
                    name="cardNo"
                    placeholder="'-' 없이 입력하세요"
                    autocomplete="off"
                    class="input-text input-width-medium input-font "
                    title="납부 가능한 카드번호 입력"
                    maxlength="16"
                    @input="onlyNumber"
                    ref="ref_cardNo"
                  />
                </dd>
              </dl>
              <dl class="field-control-sub sub-form">
                <dt>
                  <label class="input-sub-text w120 mw100"
                    >유효기간(년/월)</label
                  >
                </dt>
                <dd class="m-input-half">
                  <dl class="m-input-half-sub">
                    <dt>
                      <label
                        for="verification-card-expired-year"
                        class="input-sub-text blind"
                        >년</label
                      >
                    </dt>
                    <dd>
                      <select
                        id="verification-card-expired-year"
                        v-model="year"
                        ref="ref_cardNoYear"
                        class="input-width-xsmall mw100"
                        title="본인인증 가능한 신용카드의 유효기간 년 선택"
                      >
                        <option
                          v-for="year in yearList"
                          :value="year"
                          :key="year"
                          >{{ year }}</option
                        >
                      </select>
                    </dd>
                  </dl>
                  <span class="field-group-space">/</span>
                  <dl class="m-input-half-sub">
                    <dt>
                      <label
                        for="verification-card-expired-month"
                        class="input-sub-text blind"
                        title="본인인증 가능한 신용카드의 유효기간 월 선택"
                        >월</label
                      >
                    </dt>
                    <dd>
                      <select
                        id="verification-card-expired-month"
                        v-model="month"
                        class="input-width-xsmall mw100"
                        ref="ref_cardNoMonth"
                      >
                        <option
                          v-for="month in monthList"
                          :value="month"
                          :key="month"
                          >{{ month }}</option
                        >
                      </select>
                    </dd>
                  </dl>
                </dd>
              </dl>
              <div class="field-control-sub">
                <div class="m-input-half">
                  <button
                    type="submit"
                    @click="getCcrdCnfmCheck"
                    class="m-right m-input-half-sub"
                    ref="ref_cardSubmit"
                  >
                    인증하기
                  </button>
                </div>
              </div>
            </div>
            <!--                <span v-if="this.payType==='C'"><input type="number" autocomplete='off' name="cardNo" placeholder="'-' 없이 입력하세요" class='input-text input-width-small input-font '><button type='submit'>인증하기</button></span>-->
          </dd>
        </dl>
      </div>
    </div>
    <v-dialog />
  </div>
</template>

<script>
import { getCcrdCnfm, getPymInfoVaildation } from '@/api/captureService'
import { commCode } from '@/api/step3/identificationVerfication'
import { getComCodeList } from '@/api/metaService'
import { validAccount, retrieveDateList } from '@/api/common'
export default {
  name: 'PayInformationSection',

  props: {
    registrationProps: Object
  },

  data() {
    return {
      registration: {},
      payType: 'NA',
      year: '',
      month: '',
      yearList: [],
      monthList: [],
      creditInfo: {},
      pymInfo: {},

      isVerify: false,

      selectedBank: {},
      selectedCcrdCmpy: {},
      bankList: [],
      cardList: []
    }
  },
  computed: {},

  components: {},
  mounted() {
    this.registration = this.registrationProps
    this.isVerify = false
    this.getBankCardList()

    // 년도 조회
    this.yearList = retrieveDateList("year")
    this.year = 
      this.registration.ccrdValdTermEndYymm === ''
        ? this.yearList[0]
        : this.registration.ccrdValdTermEndYymm.substr(0, 4)
    // 월 조회
    this.monthList = retrieveDateList("month")
    this.month = 
      this.registration.ccrdValdTermEndYymm === ''
        ? this.monthList[0]
        : this.registration.ccrdValdTermEndYymm.substr(4, 2)
  },

  methods: {
    /** 
     * Function    : getBankCardList
     * Description : 은행, 카드 리스트 조회
     **/
    getBankCardList() {
      Promise.all([getComCodeList('G125'), getComCodeList('G126')]).then(
        responses => {
          this.bankList = responses[0].data
          this.cardList = responses[1].data
        }
      )
    },

    /** 
     * Function    : onlyNumber
     * Description : input값 숫자 체크
     **/
    onlyNumber(e) {
      if(e.target.name === 'accountNo') this.registration.acctCardNo = e.target.value.replace(/[^0-9]/gi, '')
      if(e.target.name === 'cardNo') this.registration.acctCardNo = e.target.value.replace(/[^0-9]/gi, '')
    },

    /** 
     * Function    : validCondition
     * Description : 출금 결제 필수값 validation
     **/
    validCondition() {
      let regExp
      let title = '온라인 가입신청 안내'
      if (this.registration.wdrwAgrYn !== 'Y') {
        this.openAlert(
          title,
          '출금 결제 동의여부를 확인하세요.',
          this.$refs.ref_payAgreement
        )
        return false
      }
      // if (this.registration.paymMthdDivsCd !== 'G') {
      // }
      if (this.registration.paymMthdDivsCd === '') {
        this.openAlert(
          title,
          '요금납부 유형을 선택하세요.',
          this.$refs.ref_payInfo
        )
        return false
      }
      if (this.registration.paymMthdDivsCd === 'B') {
        if (!this.registration.onetBankCd) {
          this.openAlert(title, '은행을 선택하세요.', this.$refs.ref_banks)
          return false
        }
        if (!this.registration.acctCardNo) {
          this.openAlert(
            title,
            '계좌번호를 입력하세요.',
            this.$refs.ref_accountNo
          )
          return false
        }

        if (!this.checkAccountInfo()) {
          this.openAlert(title, '해당계좌번호는 자동이체 출금이 되지 않는 계좌입니다.\n자동이체 출금이 가능한 계좌번호를 등록하여 주시기 바랍니다.', this.$refs.ref_banks)
          return false
        }
        // regExp = /^[0-9]$/;
        // if(!regExp.test(this.registration.acctCardNo)) {
        //   this.openAlert(title, "계좌번호는 숫자만 입력해주세요.", this.$refs.ref_accountNo)
        //   return false
        // }
        if (!this.isVerify) {
          this.openAlert(
            title,
            '인증을 완료해주세요.',
            this.$refs.ref_bankSubmit
          )
          return false
        }
      }
      if (this.registration.paymMthdDivsCd === 'C') {
        if (!this.registration.onetCdcoCd) {
          this.openAlert(title, '카드사를 선택하세요.', this.$refs.ref_cards)
          return false
        }
        if (!this.registration.acctCardNo) {
          this.openAlert(title, '카드번호를 입력하세요.', this.$refs.ref_cardNo)
          return false
        }
        if (!this.year) {
          this.openAlert(
            title,
            '유효기간 년을 입력하세요.',
            this.$refs.ref_cardNoYear
          )
          return false
        }
        if (!this.month) {
          this.openAlert(
            title,
            '유효기간 월을 입력하세요.',
            this.$refs.ref_cardNoMonth
          )
          return false
        }
        if (!this.isVerify) {
          this.openAlert(
            title,
            '인증을 완료해주세요.',
            this.$refs.ref_cardSubmit
          )
          return false
        }
      }

      return true
    },

    /** 
     * Function    : checkAccountInfo
     * Description : 은행별 필수값 validation
     **/
    checkAccountInfo() {
      let cSelBank = this.registration.onetBankCd
      var cBankAccount = this.registration.acctCardNo;
      let bool = true;
      // 기업(003) : 10,11자리계좌 차단 (평생계좌체계)
      if (cSelBank == "003"){
        if(cBankAccount.length == 10 || cBankAccount.length == 11){
          bool = false;
          return false;
        }
      }
      // 대구(031) : 10자리 이하 계좌 차단 (평생계좌체계) 
      if (cSelBank == "031"){
        if(cBankAccount.length <= 10){
          bool = false;
          return false;	
        }
      }
      // 신한(088) : 010시작계좌 및 561,562시작계좌(가상계좌)차단 
      if (cSelBank == "088"){
        if(cBankAccount.substring(0, 3) == "010" || cBankAccount.substring(0, 3) == "561" || cBankAccount.substring(0, 3) == "562"){
          bool = false;
          return false;	
        }			
      }
      //농협중앙회(011)   : 10, 13자리계좌의 마지막 자리 8 차단 
      if (cSelBank == "011"){
        if(cBankAccount.length == 10 || cBankAccount.length == 13){
          if(cBankAccount.charAt(cBankAccount.length-1) == "8"){
            bool = false;
            return false;
          }
        }
      }
      // 농협회원조합(012) : 10, 13자리 계좌의 마지막 자리 9 차단 
      if (cSelBank == "012"){
        if(cBankAccount.length == 10 || cBankAccount.length == 13){
          if(cBankAccount.charAt(cBankAccount.length-1) == "9"){
            bool = false;
            return false;
          }
        }
      }
      return bool
    },

    /** 
     * Function    : openAlert
     * Description : 기본 alert 호출 함수
     **/
    openAlert(title, message, ref) {
      this.$modal.show('dialog', {
        text: message,
        title: title,
        buttons: [
          {
            title: '확인',
            class: 'primary-button',
            handler: () => {
              if (ref) {
                ref.focus()
              }
              this.$modal.hide('dialog')
            }
          }
        ]
      })
    },

    /** 
     * Function    : getCcrdCnfmCheck
     * Description : 신용카드 인증
     **/
    getCcrdCnfmCheck() {
      let reqData = {
        acntOwnrNo: this.registration.pymnBday,
        pymCustNm: this.registration.pymnNm,
        bankCd: this.registration.onetCdcoCd,
        pymMthdCd: 'CC',
        cardValdEndYymm: this.year + this.month,
        bankAcntNo: this.registration.acctCardNo,
        custKdCd: this.registration.custKdCd,
        appfNo : this.registration.crypAppfNo
      }
      validAccount(reqData).then(res => {
        let result = res.data.dsRsltInfo
        if (result.rsltCd === 'SUCCESS') {
          this.isVerify = true
          this.openAlert('신용카드 인증', '인증성공')
        } else {
          this.isVerify = false
          this.openAlert('인증 오류', result.rsltMsg)
        }
      })
    },

    /** 
     * Function    : getPymInfoVaildation
     * Description : 계좌번호 인증
     **/
    getPymInfoVaildationCheck() {
      let reqData = {
        acntOwnrNo: this.registration.pymnBday,
        pymCustNm: this.registration.pymnNm,
        bankCd: this.registration.onetBankCd,
        pymMthdCd: 'CM',
        bankAcntNo: this.registration.acctCardNo,
        custKdCd: this.registration.custKdCd,
        appfNo : this.registration.crypAppfNo
      }
      validAccount(reqData).then(res => {
        let result = res.data.dsRsltInfo
        if (result.rsltCd === 'SUCCESS') {
          this.isVerify = true
          this.openAlert('계좌번호 인증', '인증성공')
        } else {
          this.isVerify = false
          this.openAlert('인증 오류', result.rsltMsg)
        }
      })
    },

    /** 
     * Function    : changePayType
     * Description : 납부방법 변경시 초기화
     **/
    changePayType() {
      this.selectedBankCd = ''
      this.selectedCcrdCmpyCd = ''
      this.year = ''
      this.month = ''
      this.registration.onetBankCd = ''
      this.registration.onetCdcoCd = ''
      this.registration.bankNm = ''
      this.registration.CdcoNm = ''
      this.registration.acctCardNo = ''
      this.registration.ccrdValdTermEndYymm = ''
    },

    /** 
     * Function    : changeBankCd
     * Description : 은행명 셀렉트박스 변경 이벤트
     **/
    changeBankCd(event) {
      if (event.target.value !== '') {
        this.registration.onetBankCd = event.target.value
        let bankList = this.bankList.data
        for (let index in bankList) {
          if (bankList[index].cmmCdv === event.target.value) {
            this.selectedBank = bankList[index]
          }
        }
        this.registration.bankNm = this.selectedBank.cmmCdvNm
      }
    },

    /** 
     * Function    : changeCcrdCmpyCd
     * Description : 신용카드사명 셀렉트박스 변경 이벤트
     **/
    changeCcrdCmpyCd(event) {
      if (event.target.value !== '') {
        this.registration.onetCdcoCd = event.target.value
        let cardList = this.cardList
        for (let index in cardList) {
          if (cardList[index].cmmCdv === event.target.value) {
            this.selectedCcrdCmpy = cardList[index]
          }
        }
        this.registration.CdcoNm = this.selectedCcrdCmpy.cmmCdvNm
      }
    },

    /** 
     * Function    : savePayInformationSection
     * Description : 납부정보 저장
     **/
    savePayInformationSection() {
      if(this.registration.paymMthdDivsCd === 'C') {
        this.registration.ccrdValdTermEndYymm = this.year + this.month
      }
      return this.registration
    }
  }
}
</script>

<style scoped></style>
